import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Reports from "./intermediaries/sections/Reports";
import Printouts from "./intermediaries/sections/Printouts";
import { useRouteMatch } from "../utils/RouteMatch";
import SectionHeader from "../../../util/component/SectionHeader";
import { useHasScope } from "../../../config/globalConfig";
import { SCOPE_FINANCE_VIEW_INTERMEDIARIES_PRINTOUTS, SCOPE_FINANCE_VIEW_INTERMEDIARIES_REPORTS } from "./intermediaries/constants/ConstantsAuth";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";

const PageIntermediaries = () => {
    const {t} = useTranslation('finance', {keyPrefix: 'intermediaries'});
    const navigate = useNavigate();
    const location = useLocation();
    const hasScope = useHasScope;
    const ROUTING = [
        {id: 0, name: t('tabs.report'), pathname: '/finance/intermediaries/', visible: hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_REPORTS)},
        {id: 1, name: t('tabs.printout'), pathname: '/finance/intermediaries/printouts', visible: hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_PRINTOUTS)},
    ];

    const routeMatch = useRouteMatch(ROUTING.map(it => it.pathname));
    const currentTab = routeMatch?.pattern?.path;

    useEffect(() => {
        if (location.pathname === "/finance/intermediaries/report") {
            navigate("/finance/intermediaries");
        }
    })

    return (
        hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_REPORTS) || hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_PRINTOUTS) ?
            <Box>
                <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={currentTab ? currentTab : false}>
                        {ROUTING.filter(it => it.visible).map(it =>
                            <Tab key={it.id} label={it.name} value={it.pathname}
                                 to={it.pathname} component={Link}/>)}
                    </Tabs>
                </Box>
                <Routes>
                    {hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_REPORTS) &&
                        <Route path="/" element={<Reports/>}/>}
                    {hasScope(SCOPE_FINANCE_VIEW_INTERMEDIARIES_PRINTOUTS) &&
                        <Route path="/printouts" element={<Printouts/>}/>}
                </Routes>
            </Box>
        : <NotAuthorizedDialog/>
    );
}
export default PageIntermediaries;